import { PageContent, PageSectionHeader } from 'components/page';
import { useReduxState } from 'hooks';
import {
  HomeDetailsExpiringCompletions,
  HomeDetailsPendingRequests,
  HomeDetailsUnreadChatMessages,
  HomeDetailsUnreadFeedbacks,
  HomeDetailsUnreviewedAnswers,
  HomeDetailsUpcomingEvents,
  HomeDetailsUpcomingTargetSchedules
} from '.';

export type HomeDetailsViewType =
  | 'expiring-completions'
  | 'pending-requests'
  | 'unreviewed-answers'
  | 'unread-chat-messages'
  | 'unread-feedbacks'
  | 'upcoming-events'
  | 'upcoming-target-schedules';

interface Props {
  type: HomeDetailsViewType;
}

const HomeDetailsView = ({ type }: Props) => {
  const { messages } = useReduxState();

  const typeData = {
    'expiring-completions': {
      title: messages.completionsExpiring,
      DetailsComponent: HomeDetailsExpiringCompletions
    },
    'pending-requests': {
      title: messages.commonPendingRequests,
      DetailsComponent: HomeDetailsPendingRequests
    },
    'unread-chat-messages': {
      title: messages.courseUnreadChatMessages,
      DetailsComponent: HomeDetailsUnreadChatMessages
    },
    'unread-feedbacks': {
      title: messages.summaryUnreadFeedbacks,
      DetailsComponent: HomeDetailsUnreadFeedbacks
    },
    'unreviewed-answers': {
      title: messages.summaryUnreviewedAnswers,
      DetailsComponent: HomeDetailsUnreviewedAnswers
    },
    'upcoming-events': {
      title: messages.eventCalendarUpcomingEvents,
      DetailsComponent: HomeDetailsUpcomingEvents
    },
    'upcoming-target-schedules': {
      title: messages.commonUpcomingTargetSchedules,
      DetailsComponent: HomeDetailsUpcomingTargetSchedules
    }
  };

  const { title, DetailsComponent } = typeData[type];

  return (
    <PageContent>
      <PageSectionHeader title={title} />
      <div className="view">
        <DetailsComponent />
      </div>
    </PageContent>
  );
};
export default HomeDetailsView;
